import { render, staticRenderFns } from "./ShopifyImage.vue?vue&type=template&id=5cfb4fa4&scoped=true&"
import script from "./ShopifyImage.vue?vue&type=script&lang=js&"
export * from "./ShopifyImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb4fa4",
  null
  
)

export default component.exports